import request from '@/config/axios'

export interface TradeOrderComplaintVO {
  id?: number
  orderId?: number
  orderNo?: string
  userId?: number
  userNickname?: string
  shopId?: number
  shopName?: string
  type?: number
  content?: string
  picUrls?: string[]
  contact?: string
  createTime?: string
}

export const getOrderComplaintPage = async (params: Recordable) => {
  return await request.get({ url: `/trade/order-complaint/page`, params })
}

export const getOrderComplaint = async (id: number) => {
  return await request.get({ url: `/trade/order-complaint/get`, params: { id } })
}
